import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_to_catalog_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
  catalog_hdr_guid: fromDatatype.GuidDataFieldInterface;
  catalog_line_guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
  edition_pricing_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_applet_to_catalog_link_RowClass
  implements bl_applet_to_catalog_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
  catalog_hdr_guid: fromDatatype.GuidDataFieldInterface;
  catalog_line_guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
  edition_pricing_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
